/**
 * Theme Requirements Aggregation for Aion Management
 * 
 * Extends the base comfy theme requirements with Aion Management specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-comfy/requirements';

/**
 * Aion Management component requirement overrides.
 * Add requirements for any override components here.
 */
const aionmanagementOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Aion Management theme.
 * Inherits from comfy theme and overrides with Aion Management components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...aionmanagementOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
